export enum ELanguageCode {
    EN = 'en',
    AR = 'ar',
}